import { lazy } from 'react'

const CareerHubRoute = lazy(async () => {
  const { CareerHub } = await import(/* webpackChunkName: "careerhub" */ './index')

  return {
    default: CareerHub
  }
})
const routes = [
  {
    path: '/careerhub',
    authenticated: true,
    render(props) {
      return <CareerHubRoute {...props} />
    }
  }
]

export { routes }
